import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { OrderDetailsPageContext } from "@insite/content-library/Pages/OrderDetailsPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

export interface OrderWriterStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    OrderWriter?: TypographyProps;
}

export const OrderWriterStyles: OrderWriterStyles = {
    wrapper: {
        css: css`
            padding-bottom: 10px;
        `,
    },
    titleText: {
        variant: "h6",
        as: "h2",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
        `,
    },
};

const styles = OrderWriterStyles;

const OrderWriter: FC = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order || !order?.properties.writer) {
        return null;
    }
    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="OrderWriter">
                {translate("Writer")}
            </Typography>
            <Typography {...styles.OrderWriter} aria-labelledby="OrderWriter">
                {order?.properties.writer}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderWriter,
    definition: {
        allowedContexts: [OrderDetailsPageContext],
        group: "Order Details",
    },
};

export default widgetModule;
